<template>
  <div
    class="yandle-logo-wrap"
    :class="[variantClass, imgClass]"
    :style="wrapStyle"
    role="img"
    :aria-label="alt"
  >
    <svg
      class="yandle-logo"
      :width="size"
      :height="size"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          :id="`${uid}-bg`"
          x1="8"
          y1="6"
          x2="40"
          y2="42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0f172a" />
          <stop offset="0.55" stop-color="#1e293b" />
          <stop offset="1" stop-color="#0544e2" />
        </linearGradient>
        <linearGradient
          :id="`${uid}-mark`"
          x1="18"
          y1="14"
          x2="30"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ffffff" />
          <stop offset="1" stop-color="#e0e7ff" />
        </linearGradient>
        <linearGradient
          :id="`${uid}-accent`"
          x1="20"
          y1="30"
          x2="28"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0544e2" />
          <stop offset="1" stop-color="#2563eb" />
        </linearGradient>
      </defs>

      <rect width="48" height="48" rx="12" :fill="`url(#${uid}-bg)`" />

      <rect
        x="4"
        y="4"
        width="40"
        height="40"
        rx="9"
        stroke="rgba(255, 255, 255, 0.08)"
        stroke-width="1"
        fill="none"
      />

      <path
        d="M24 14L17.5 26H20.4L24 20.2L27.6 26H30.5L24 14Z"
        :fill="`url(#${uid}-mark)`"
      />
      <path
        d="M22.4 26H25.6V29.8H22.4V26Z"
        :fill="`url(#${uid}-mark)`"
      />

      <circle cx="24" cy="33.2" r="3" :fill="`url(#${uid}-accent)`" />
      <circle cx="24" cy="33.2" r="1.2" fill="#09090f" />
    </svg>
  </div>
</template>

<script>
/** Public checkout URL for the YandleLogo mark (matches public/favicon.svg). */
export function getYandleLogoCheckoutUrl() {
  const base = process.env.BASE_URL || '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`
  return `${window.location.origin}${normalizedBase}favicon.svg`
}

let logoInstance = 0

export default {
  name: 'YandleLogo',
  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
    alt: {
      type: String,
      default: 'Yandle',
    },
    imgClass: {
      type: String,
      default: '',
    },
    /** sidebar | login | default */
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    logoInstance += 1
    return {
      uid: `yandle-logo-${logoInstance}`,
    }
  },
  computed: {
    variantClass() {
      return `yandle-logo-wrap--${this.variant}`
    },
    wrapStyle() {
      const s = Number(this.size) || 32
      return {
        width: `${s}px`,
        height: `${s}px`,
      }
    },
  },
}
</script>

<style scoped>
.yandle-logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
}

.yandle-logo {
  display: block;
  width: 100%;
  height: 100%;
}

.yandle-logo-wrap--sidebar {
  border-radius: 10px;
  box-shadow:
    0 0 0 1px rgb(var(--v-theme-shell-border)),
    0 4px 14px rgba(0, 0, 0, 0.28);
}

.yandle-logo-wrap--login {
  border-radius: 14px;
  box-shadow:
    0 0 0 1px rgb(var(--v-theme-shell-border)),
    0 10px 36px rgba(99, 102, 241, 0.28);
}
</style>
